// @flow strict

import * as React from 'react';

type Props = {|
  /** The number of pixels to shift in the X dimension */
  x: number,

  /** The number of pixels to shift in the Y dimension */
  y: number,

  /** React children */
  children: React.Node,
|};

/**
 * Shift lets you do pixel-level position adjustment of an element.
 *
 * For example, to move an overlay up 10px and to the right 10px, you could simply wrap the contents in a
 * <Shift y={-10} x={10}>{contents}</Shift>. Because <Overlay> elements are "positioned", Shift can use simple
 * relative positioning to do these sorts of minor pixel adjustments.
 */
const Shift = ({ x, y, children }: Props) => (
  <div style={{ transform: `translate(${x}px, ${y}px)` }}>{children}</div>
);

Shift.defaultProps = {
  x: 0,
  y: 0,
};

export default Shift;
